import { ca } from '@cian/analytics';

import { trackingReasonToListingType } from '../constants/tracking';
import { TPublicWebV1SearchResponse_MlRanking } from '../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { ITrackOfferActionsProps } from '../types/tracking';

export function trackOfferCardShow(
  { offerPosition, offerId, jsonQuery, pageNumber, offersLength, queryString, reason }: ITrackOfferActionsProps,
  mlRanking: TPublicWebV1SearchResponse_MlRanking | undefined,
  mlSearchSessionGuid: string | null | undefined,
) {
  ca('teaser', {
    sc: jsonQuery,
    product: {
      screen: 'Listing',
      block: 'Listing_snippet',
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
      },
      position: offerPosition,
    },
    page: {
      // Карточка в шторке пина - показ на карте, как её to_card
      listingType: trackingReasonToListingType[reason],
      pageType: 'Listing',
      offersQty: offersLength,
      pageNumber,
      extra: {
        mobileWebsiteType: 'new',
        mlSearchSessionGuid,
        mlRankingGuid: mlRanking?.guid,
        mlRankingModelVersion: mlRanking?.modelVersion,
      },
      siteType: 'mobile',
      queryString,
    },
  });
}
